import React from 'react';
import { BookOpen } from 'lucide-react';

interface ContextNotePillProps {
  name: string;
  scope: 'user' | 'tenant';
  tags?: React.ReactNode;
}

export const ContextNotePill = ({
  name,
  scope,
  tags,
}: ContextNotePillProps) => {
  const isTenant = scope === 'tenant';

  return (
    <span
      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full border text-[11px] ${
        isTenant
          ? 'bg-sky-50 border-sky-200 text-sky-900'
          : 'bg-amber-50 border-amber-200 text-amber-950'
      }`}>
      <BookOpen className="h-3 w-3 flex-shrink-0" />
      <span className="font-medium">{name}</span>
      {tags}
    </span>
  );
};
